import filter from 'lodash/filter'

function getNames(
    module: any,
    nickname: string,
    opeName: string,
    opeID: number,
    userID: number
): string[] {
    if (!module) {
        return []
    }

    switch (module.type) {
        case 'user':
            return [nickname]
        case 'operation':
            return [opeName]
        case 'group':
            const groups = filter(module.groups, {
                operation: {
                    id: opeID,
                },
                groupUsers: [
                    {
                        user: {
                            id: userID,
                        },
                    },
                ],
            })
            const names = groups.map((group: any) => group.name)
            return names
    }
}

export { getNames }
